import { API_KEY_PREFIX } from "../../apiKeyPrefix";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const threeB = defineConnector({
  identifier: "threeB",
  name: "Tines 3B",
  tagLine: "Automate 3B itself",
  logo,
  protocol: "http",
  tags: ["featured", "engineering"],
  defaultUrlPattern: () => "{API_URL}",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content: "Go to your 3B instance's settings and create an API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          placeholder: `${API_KEY_PREFIX}…`,
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
    {
      title: "Enter your API URL",
      items: [
        {
          kind: "url",
          label: "API URL",
          required: true,
          defaultValue: "{API_URL}",
          target: { kind: "configuration", field: "apiUrl" },
          helperText: "The base URL of your 3B API.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiUrl }) => `${apiUrl}/health`,
  },
  publicEnvVars: ({ apiUrl }) => ({
    THREE_B_API_URL: apiUrl ?? "",
  }),
});
